import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Card,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import { useQueryParams } from "use-query-params";
import TabArticle from "./Article";
import TabBody from "./Body";
import TabCampaign from "./Campaign";
import TabSubject from "./Subject";
import TabInfoGraphic from "./InfoGraphic";

const Vote = () => {
    const { t, i18n } = useTranslation();

    const [activeTab, setActiveTab] = useState("CAMPAIGN");

    const [query, setQuery]: any = useQueryParams({});

    const tabChange = (tab: any) => {
        if (activeTab !== tab) {
            setQuery({}, "push");
            setActiveTab((_prev) => tab);
        }
    };

    useEffect(() => {
        document.title = `${t('Vote')} - ${t('Boosting Content')} | PRESS Ai`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("Vote")} pageTitle={t("Boosting Content")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="CAMPAIGN"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <div
                                    style={{
                                        background: "#f3f6f9",
                                        borderTopLeftRadius: "0.6rem",
                                        borderTopRightRadius: "0.6rem",
                                    }}
                                >
                                    <div
                                        className="d-block"
                                        style={{
                                            background: "#f3f6f9",
                                            borderRadius: "0.6rem",
                                            width: "fit-content",
                                        }}
                                    >
                                        <Nav tabs className="nav nav-tabs nav-link-none-hover nav-justified">
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "CAMPAIGN" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "CAMPAIGN" ? "white" : "unset"}`,
                                                        borderTopRightRadius: 0
                                                    }}
                                                    onClick={() => tabChange("CAMPAIGN")}
                                                >
                                                    {t("Campaign")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '90px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "SUBJECT" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "SUBJECT" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("SUBJECT")}
                                                >
                                                    {t("Subject")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '90px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "BODY" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "BODY" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("BODY")}
                                                >
                                                    {t("Body")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '120px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "INFO_GRAPHIC" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "INFO_GRAPHIC" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("INFO_GRAPHIC")}
                                                >
                                                    {t("Info-Graphic")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '90px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "ARTICLE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "ARTICLE" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("ARTICLE")}
                                                >
                                                    {t("Article")}
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="CAMPAIGN">
                                        {activeTab === "CAMPAIGN" && (
                                            <TabCampaign activeTab={activeTab} />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="SUBJECT">
                                        {activeTab === "SUBJECT" && (
                                            <TabSubject activeTab={activeTab} />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="BODY">
                                        {activeTab === "BODY" && (
                                            <TabBody activeTab={activeTab} />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="INFO_GRAPHIC">
                                        {activeTab === "INFO_GRAPHIC" && (
                                            <TabInfoGraphic activeTab={activeTab} />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="ARTICLE">
                                        {activeTab === "ARTICLE" && (
                                            <TabArticle activeTab={activeTab} />
                                        )}
                                    </TabPane>
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Vote;
